import { Apps } from "@memorang/constants/apps";
import MaterialDesignIcons from "@react-native-vector-icons/material-design-icons/static";
import type { ComponentProps } from "react";
import { useAppConfig } from "../../contexts/AppConfigContext";
import type { IconType } from "../../icon";
import { pearsonGlyphNames } from "../../icons/pearson-glyphs";
import { pearsonIconMap } from "../../icons/pearson-icon-map";
import { PearsonIcons } from "../PearsonIcons";

type Props = Omit<ComponentProps<typeof MaterialDesignIcons>, "name"> & {
	name: IconType;
};

const isPearsonMappedIcon = (
	name: IconType,
): name is keyof typeof pearsonIconMap => name in pearsonIconMap;

export const AppIcon = ({ name, size, color, ...rest }: Props) => {
	const { buildType } = useAppConfig();
	const pearsonName = isPearsonMappedIcon(name)
		? pearsonIconMap[name]
		: undefined;

	const usePearson =
		buildType === Apps.pte &&
		pearsonName !== undefined &&
		pearsonGlyphNames.has(pearsonName);

	if (usePearson) {
		return (
			<PearsonIcons name={pearsonName} size={size} color={color} {...rest} />
		);
	}

	return (
		<MaterialDesignIcons name={name} size={size} color={color} {...rest} />
	);
};
